export default {"src":"/_next/static/media/risk-tolerance.274e2679.svg","height":35,"width":36,"blurWidth":0,"blurHeight":0};